import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import decryptCookieData from './Functions/decryptCookieData';



const Track = () => {
    const [activeStep, setActiveStep] = useState(1);
    const steps = ["Order Placed", "Dispatch", "Out for delivery", "Delivered"];

    let navigate = useNavigate();
    let [order, setOrder] = useState({});
    let [orderprod, setOrderProd] = useState([])
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    let { id } = useParams()
    let [totalPrice, setTotalPrice] = useState(0);
    let [totalStrikeOffPrice, setTotalStrikeOffPrice] = useState(0);
    let [addresspro, setAddressPro] = useState({})
    const url = process.env.REACT_APP_API_URL
    const statusToStep = {
        "Pending": 1,
        "Processing": 1,
        "Packed": 1,
        "Shipped": 2,
        "Out for delivery": 3,
        "Delivered": 4,
        "Cancelled": -1  // Special flag for cancelled
    };


    const getStepLabel = (stepIndex, currentStatus) => {
        if (currentStatus === "Cancelled") return "Cancelled";

        switch (stepIndex) {
            case 0:
                return currentStatus === "Processing" ? "Order Processing"
                    : currentStatus === "Packed" ? "Packed"
                        : "Order Placed";
            case 1:
                return "Dispatch";
            case 2:
                return "Out for delivery";
            case 3:
                return "Delivered";
            default:
                return "";
        }
    };
    const fetchOrderData = async () => {
        try {
            const response = await fetch(`${url}/payment/order/${id}`);
            const res = await response.json();
            const data = res.data;
            console.log(data)
            // ✅ Parse cart_products if it's a string
            const parsedCartProducts = typeof data.cart_products === 'string'
                ? JSON.parse(data.cart_products)
                : data.cart_products;

            setOrder(data);
            setOrderProd(parsedCartProducts);

            // Set the progress step
            const step = statusToStep[data.orderStatus] !== undefined ? statusToStep[data.orderStatus] : 1;
            setActiveStep(step);

            // Set calculated price (optional logic)
            let totalPrice = 0;
            let totalStrikeOffPrice = 0;
            setTotalPrice(totalPrice);
            setTotalStrikeOffPrice(totalStrikeOffPrice);
        } catch (error) {
            console.error("❌ Order Fetch Error:", error);
        }
    };




    console.log(totalPrice)
    console.log(totalStrikeOffPrice)

    let logout = () => {

        localStorage.removeItem("login");
        window.location.reload();
    }

    useEffect(() => {
        fetchOrderData();
    }, [])

    return (
        <>

            {/* <div className="track">
                <img src={track} alt="Track your order" />
            </div> */}
            <div className="track-mapping">
                <div className="track-order-number">
                    <p className="order-id">Order #{order.receipt_id}</p>
                </div>
                <div className="mapping">
                    {steps.map((_, index) => (
                        <React.Fragment key={index}>
                            <div
                                className={`step 
          ${activeStep > index + 1 ? "active" : ""}
          ${activeStep === index + 1 ? "active pulse" : ""}
          ${activeStep === -1 ? "cancelled" : ""}
        `}
                            >
                                <span className={`dot ${activeStep === -1 && index === 3 ? "cancel-cross" : ""}`}></span>
                                <p>{getStepLabel(index, order.orderStatus)}</p>
                            </div>
                            {index < steps.length - 1 && <div className="line"></div>}
                        </React.Fragment>
                    ))}
                </div>

            </div>
            <div className="track-orders-list">
                <div className="ordered-items">Ordered Items</div>
                {orderprod.map((product, index) => (
                    <div className="item-list" key={index}>
                        <div className="ordered-item-img">
                            <img
                                src={`${url}${product.product_image}`}
                                alt={product.product_name}
                            />
                        </div>
                        <div className="ordered-item-detail">
                            <p className="product-name">{product.product_name}</p>
                            <p className="actual-amount">
                                <span className="line-through">₹{Number(product.product_price).toFixed(2)}</span>
                                <span className="percent-discount">
                                    {Math.round(
                                        ((Number(product.product_price) - Number(product.product_saleprice)) /
                                            Number(product.product_price)) *
                                        100
                                    )}
                                    % Off
                                </span>
                            </p>
                            <div className="discount-quantity">
                                <p className="discount-amount">₹{Number(product.product_saleprice).toFixed(2)}</p>
                                {/* <p className="quantity">{product.quantity} Qty</p> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="bill-details">
                <div className="bill-details-header">Bill Details</div>
                <div className="bill-saved">
                    You saved ₹{(Number(order.amountbeforediscount) - Number(order.totalAmountbeforePay)).toFixed(2)} on this order
                </div>
                <div className="mrp-div">
                    <p className="mrp-title">MRP</p>
                    <p className="mrp">₹{Number(order.amountbeforediscount).toFixed(2)}</p>
                </div>
                <div className="discount-div">
                    <p className="discount-title">Discount</p>
                    <p className="discount">-₹{(Number(order.amountbeforediscount) - Number(order.totalAmountbeforePay)).toFixed(2)}</p>
                </div>
                {
                    order.payment_mode === "Pay on delivery" ? <div className="discount-div">
                        <p className="discount-title">Paid Amount</p>
                        <p className="discount">₹{(order.amountafterdiscount)}</p>
                    </div> : null
                }
                {
                    order.payment_mode === "Pay on delivery" ? <div className="discount-div">
                        <p className="discount-title">Remaining Amount</p>
                        <p className="discount">₹{Number(order.remaining_amount).toFixed(2)}</p>
                    </div> : null
                }

                {/* <div className="tax-div">
                    <p className="tax-title">Tax</p>
                    <p className="taxes">₹11.00</p>
                </div> */}
                {/* <div className="delivery-div">
                    <p className="delivery-title">Delivery Charges</p>
                    <p className="delivery-charge">₹{order.delivery_amount || 0.0}</p>
                </div> */}
                {
                    order.payment_mode === "Pay now" ? <div className="bill-total">
                        <p className="payable">Paid Amount</p>
                        <p className="total-amt">
                            ₹{Number(order.totalAmountbeforePay).toFixed(2)}
                        </p>
                    </div> : null
                }

                <div className="payment-mode">
                    <p className="payment-mode-title">Payment Mode</p>
                    <p className="type">{order.payment_mode === "Pay now" ? "Paid Online" : order.payment_mode}</p>
                </div>

                {
                    order.orderStatus === "Out for delivery" ?
                        <div className="download-invoice">
                            <button className="download" onClick={() => navigate(`/invoice`)}>
                                Download Invoice
                            </button>
                        </div> : null
                }

            </div>
        </>
    );

};

export default Track;
